const Button = ({ variant, children, className }) => {
  const baseStyles = className;

  // Define styles for the variants
  const variantStyles = {
    primary:
      "text-[#000] bg-[#7c0000] border-[#000] rounded-[5px] relative overflow-hidden inline-block px-[20px] py-[8px] text-[16px] leading-[24px] border-[2px] border-[solid] font-primary font-black tracking-[0.06em] whitespace-nowrap overflow-ellipsis text-center align-middle select-none [transition:250ms_all_ease-in-out]   hover:opacity-80 ",
    secondary: "",
  };

  // Select styles based on the `variant` prop
  const buttonStyles = `${baseStyles} ${
    variantStyles[variant] || variantStyles.primary
  }`;

  return <button className={buttonStyles}>{children}</button>;
};

export default Button;
